<template>
  <div class="marqueetext" v-if="item && item.length > 0">
    <p>{{ item[0].MaintainenceAlert }}</p>
    <p>{{ item[0].MaintainenceAlert }}</p>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "MaintenanceMarquee",
  data() {
    return {
      item: []
    };
  },
  methods: {
    getMaintenance() {
      const getmarqueedata = localStorage.getItem("MaintainenceData");
      if (getmarqueedata && getmarqueedata !== "null") {
        this.item = JSON.parse(getmarqueedata);
      }
    },
    checkAndCallFunction() {
      const lastCalled = localStorage.getItem("lastCalled");
      const now = Date.now();
      const threeHours = 3 * 60 * 60 * 1000; // 3 hours in ms

      if (!lastCalled || now - lastCalled > threeHours) {
        axios
          .get(
            "https://marketsmithindia.com/gateway/api/ms-india/getForceUpgradeDetails_cloud.json?prelogin=1&dt=psiweb"
          )
          .then(response => {
            localStorage.setItem(
              "MaintainenceData",
              JSON.stringify(response.data)
            );
            this.getMaintenance();
          })
          .catch(error => {
            console.error("Error fetching maintenance data:", error);
          });
        localStorage.setItem("lastCalled", now);
      } else {
        this.getMaintenance();
      }
    }
  },
  mounted() {
    this.checkAndCallFunction();
  }
};
</script>

<style scoped>
.marqueetext {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  background-color: yellow;
  color: red;
  position: fixed;
  z-index: 2024;
  padding-top: 14px;
  font-size: 16px;
  bottom: 0;
  left: 0;
}

.marqueetext p {
  animation: marqueetext 20s linear infinite;
  display: inline-block;
  margin-right: 60px;
}

@keyframes marqueetext {
  from {
    transform: translateX(30%);
  }
  to {
    transform: translateX(-120%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/marquee.vue